import React, { useRef } from "react";

import { Box, Button, Typography } from "@mui/material";
import { CollapseDetail } from "./CollapseDetail/CollapseDetail";
import { ChannelDetailForm } from "./Forms/ChannelDetailForm/ChannelDetail";
import { GenerateApi_KeyForm } from "./Forms/ChannelDetailForm/GenerateApi_Key";
import { useDispatch } from "react-redux";
import { getChannelWebHooks, updateWebHook } from "../../../Store/Features/WebHooks/SingleChannelHooks";

import "./Detail.css";


export const SettingDetail = () => {
  const dispatch = useDispatch();

  const formRef = useRef();
  return (

    <Box className="ContainserDetail">
      {/* <Box sx={{ position: "absolute", right: "70px" }}>
        <Button className="hover" id="saveButton" sx={{ background: "#EC492F", width: "93px", height: "32px", float: "right", postion: "absolute", top: "-56px" }} onClick={() => formRef.current.save()} >
          <Typography className="ButtonText">
            Save
          </Typography>
        </Button>
      </Box> */}

      <CollapseDetail Title={"Channel Settings"} >
        <ChannelDetailForm ref={formRef} />
      </CollapseDetail>
      {/* <CollapseDetail Title={"Generate Api Key "} >
        <GenerateApi_KeyForm ref={formRef} />
      </CollapseDetail> */}

    </Box>

  );
};
